import { TagType } from 'ui-components/components/tag';

import { messages } from './messages';

export const LABS_CATEGORIES = {
  INVENTORY: 'inventory',
  WAREHOUSE: 'warehouse',
  ORDERS: 'orders',
  PRODUCTS: 'products',
  AUTOMATION: 'automation',
  SUPPORT: 'support',
  ANALYTICS: 'analytics',
};

export const CATEGORY_MESSAGE_MAP = {
  [LABS_CATEGORIES.INVENTORY]: messages.categoryInventory,
  [LABS_CATEGORIES.WAREHOUSE]: messages.categoryWarehouse,
  [LABS_CATEGORIES.ORDERS]: messages.categoryOrders,
  [LABS_CATEGORIES.PRODUCTS]: messages.categoryProducts,
  [LABS_CATEGORIES.AUTOMATION]: messages.categoryAutomationRules,
  [LABS_CATEGORIES.SUPPORT]: messages.categorySupport,
  [LABS_CATEGORIES.ANALYTICS]: messages.categoryAnalytics,
};

export const CATEGORY_TAG_TYPE_MAP = {
  [LABS_CATEGORIES.INVENTORY]: TagType.Neutral,
  [LABS_CATEGORIES.WAREHOUSE]: TagType.Neutral,
  [LABS_CATEGORIES.ORDERS]: TagType.Neutral,
  [LABS_CATEGORIES.PRODUCTS]: TagType.Neutral,
  [LABS_CATEGORIES.AUTOMATION]: TagType.Neutral,
  [LABS_CATEGORIES.SUPPORT]: TagType.Neutral,
  [LABS_CATEGORIES.ANALYTICS]: TagType.Neutral,
};
